import React from "react";
import "./produk.scss";
import data from "../../Component/Card/data.json";
import Card from "../../Component/Card/card";
import Pinewoodimages from "../../Media/Summarecon Bogor/Pinewood";
import Agathisimages from "../../Media/Summarecon Bogor/Agathis";
import Ebony9images from "../../Media/Summarecon Bogor/Theebony9";
import Alderwoodimages from "../../Media/Summarecon Bogor/TheAlderwood";
import Mahoganyimages from "../../Media/Summarecon Bogor/Mahogany";
import Mapleimages from "../../Media/Summarecon Bogor/TheMaple";
import Rosewoodimages from "../../Media/Summarecon Bogor/Rosewood";

const imageMap = {
  Pinewoodimages,
  Agathisimages,
  Ebony9images,
  Alderwoodimages,
  Mahoganyimages,
  Mapleimages,
  Rosewoodimages,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <h1>Our Others Residentials</h1>

      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
